export default "__VITE_ASSET__79c60c89__"